module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-SemiboldIt.cc53a2c.eot";